import { graphql } from '@/gql';

export const GET_CONTROLLING_EINSTELLUNGEN_BY_STANDORT_ID = graphql(`
  query dienstplan_getControllingEinstellungenByStandortID(
    $standortId: String!
  ) {
    controlling(standortIds: [$standortId]) {
      einstellungen {
        absatzProduktivitaet {
          absatzVorgabe
          tagebuchAnzeige
          zielProduktivitaet
        }
        umsatzProduktivitaet {
          zielProduktivitaet
        }
      }
    }
  }
`);
